import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface User {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  avatar?: string;
  reviewedByReason: string;
}

export interface Org {
  _id: string;
  name: string;
}

export interface Leave {
  _id: string;
  user: User;
  org: Org;
  reason: string;
  fromDate: string;
  toDate: string;
  leaveType: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  reviewedBy?: User;
  reviewedByReason: string;
}

export interface LeavesData {
  pending: Leave[];
  reviewed: Leave[];
}

export interface LeavesResponse {
  success: boolean;
  data: LeavesData;
  count: {
    pending: number;
    reviewed: number;
  };
}

const fetchLeavesRequest = async (): Promise<LeavesResponse> => {
  const response = await customAxios.get<LeavesResponse>("/leaves/pending");
  return response.data;
};

export const useGetLeavesRequest = () =>
  useQuery<LeavesResponse, AxiosError>(["leaves"], fetchLeavesRequest, {
    onError: (error) =>
      showNotification({
        title: "Error Loading Leaves",
        message:
          (error.response?.data as { message?: string })?.message ||
          "Failed to load leaves",
        color: "red",
      }),
    staleTime: 1000 * 60 * 5,
    retry: 1,
    refetchOnMount: "always",
  });
